<img class="kl-loader__logo" src="/favicon.png" alt="" aria-hidden="true" />
<span class="kl-loader__label">{{ label() | translate }}</span>
<ng-content />
